import { PuebloTabsPage } from '../pueblo-tabs/pueblo-tabs';
import { VariablesGlobales } from '../../providers/variables-globales';
import { Consultas } from '../../providers/consultas';
import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ViewController } from 'ionic-angular';
import { Pueblo } from '../../models/pueblo.model';
import { BuscadorPage } from '../buscador/buscador';
import { ListaCategorias } from '../lista-categorias/lista-categorias';
import { BarrioModel } from '../../models/barrio.model';
/**
 * Generated class for the ListaPueblosPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-lista-barrios',
  templateUrl: 'lista-barrios.html',
  providers: [ Consultas ]
})
export class BarriosPage {
  public barrios:Array<BarrioModel>;
  public loader: any;
  public idCiudad: number;
  public nombrePueblo: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global: VariablesGlobales,
    public viewCtrl: ViewController) {
      this.idCiudad = this.navParams.get("idCiudad");
      this.nombrePueblo = this.navParams.get("nombrePueblo");
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BarriosPage');
  }

  goToBuscar(){
    this.navCtrl.push(BuscadorPage);
  }

  ngOnInit(){

    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(()=>{
      this.consultas.getBarriosByCiudad(this.idCiudad).subscribe(x=>
        {
          this.barrios = x;
          this.loader.dismiss();
        },error=>{
          console.error(error)
          this.loader.dismiss();
        }
        );
    });
  }

  goToCategorias(idBarrio){
    //this.navCtrl.push(ListaCategorias,{idBarrio});
    this.viewCtrl.dismiss(idBarrio);
  }

  limpiar(){
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/lista-barrios/lista-barrios.ts